export default {
    products: [],
    categories: {},
}
